import { render, staticRenderFns } from "./NlTableCell.vue?vue&type=template&id=8bfd48f8&"
import script from "./NlTableCell.vue?vue&type=script&lang=js&"
export * from "./NlTableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports